import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useNewAccountState() {
  return useAppState();
}

export function useNewAccountActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const inviteEmail = urlParams.get('invite_email');
    const inviteCode = urlParams.get('invite_code');

    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        firstName: '',
        lastName: '',
        primaryEmail: inviteEmail || '',
        password: '',
        passwordConfirmation: '',
        inviteEmail: inviteEmail || '',
        inviteCode: inviteCode || '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function updateFirstName(firstName) {
    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        ...appState.newAccountForm,
        firstName: firstName,
      },
    }));
  }

  function updateLastName(lastName) {
    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        ...appState.newAccountForm,
        lastName: lastName,
      },
    }));
  }

  function updatePrimaryEmail(primaryEmail) {
    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        ...appState.newAccountForm,
        primaryEmail: primaryEmail,
      },
    }));
  }

  function updatePassword(password) {
    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        ...appState.newAccountForm,
        password: password,
      },
    }));
  }

  function updatePasswordConfirmation(passwordConfirmation) {
    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        ...appState.newAccountForm,
        passwordConfirmation: passwordConfirmation,
      },
    }));
  }

  function updateInviteEmail(inviteEmail) {
    dispatch((appState) => ({
      ...appState,
      newAccountForm: {
        ...appState.newAccountForm,
        inviteEmail: inviteEmail,
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function goHome() {
    dispatch((appState) => ({
      ...appState,
      redirect: window.location.origin,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateFirstName,
    updateLastName,
    updatePrimaryEmail,
    updatePassword,
    updatePasswordConfirmation,
    updateInviteEmail,
    getFeedbackFromLocalStorage,
    clearFeedback,
    goHome,
  };
}
